import { ILopBan } from "../../model/respone/category/ILopBan";
import { apiClient } from "../apiClient";

export const LOP_BAN_API = "lop-ban";
export const lopBanApi = {
  SelectAll: () => apiClient.get(`${LOP_BAN_API}`),
  Insert: (payload: ILopBan) => apiClient.post(`${LOP_BAN_API}`, payload),
  Update: (payload: ILopBan) => apiClient.put(`${LOP_BAN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${LOP_BAN_API}/${id}`),
};
